<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="800"
        :fullscreen="isMobile" persistent scrollable @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica mezzo' : 'Nuovo mezzo' }}</v-card-title>
            <v-card-text>
                <v-form ref="formMezzo">
                    <div class="text-subtitle-2 text-medium-emphasis mb-2">Informazioni di base</div>
                    <v-row>
                        <v-col cols="12" sm="6"><v-text-field v-model="form.nome" label="Nome mezzo"
                                :rules="[v => !!v || 'Campo obbligatorio']" required /></v-col>
                        <v-col cols="6" sm="3"><v-text-field v-model="form.codice" label="Codice interno" /></v-col>
                        <v-col cols="6" sm="3"><v-select v-model="form.stato" :items="statiDisponibili"
                                item-title="label" item-value="value" label="Stato" /></v-col>
                    </v-row>

                    <v-divider class="my-4" />
                    <div class="text-subtitle-2 text-medium-emphasis mb-2">Dettagli tecnici</div>
                    <v-row>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.targa" label="Targa" /></v-col>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.marca" label="Marca" /></v-col>
                        <v-col cols="12" sm="4"><v-text-field v-model="form.modello" label="Modello" /></v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-combobox v-model="form.categoria" :items="categorieSuggerite" label="Categoria"
                                hint="Es. Automezzo, Attrezzatura" persistent-hint />
                        </v-col>
                    </v-row>

                    <v-divider class="my-4" />
                    <v-row>
                        <v-col cols="12" sm="6">
                            <div class="text-subtitle-2 text-medium-emphasis mb-2">Descrizione</div>
                            <v-textarea v-model="form.descrizione" label="Descrizione" rows="3" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <div class="text-subtitle-2 text-medium-emphasis mb-2">Note</div>
                            <v-textarea v-model="form.note" label="Note" rows="3" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { STATI_MEZZO } from "@/constants/statoMezzo.js";

export default {
    name: "DialogMezzo",

    props: {
        modelValue: { type: Boolean, default: false },
        mezzo: { type: Object, default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
            statiDisponibili: STATI_MEZZO,
            categorieSuggerite: ["Automezzo", "Attrezzatura"],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
    },

    watch: {
        modelValue(val) {
            if (val) this.inizializza();
        },
    },

    methods: {
        formVuoto() {
            return {
                id: null,
                codice: "",
                nome: "",
                targa: "",
                marca: "",
                modello: "",
                categoria: "",
                descrizione: "",
                note: "",
                stato: "Attivo",
            };
        },

        inizializza() {
            this.form = this.mezzo
                ? {
                    id: this.mezzo.id,
                    codice: this.mezzo.codice,
                    nome: this.mezzo.nome,
                    targa: this.mezzo.targa,
                    marca: this.mezzo.marca,
                    modello: this.mezzo.modello,
                    categoria: this.mezzo.categoria,
                    descrizione: this.mezzo.descrizione,
                    note: this.mezzo.note,
                    stato: this.mezzo.stato,
                }
                : this.formVuoto();
        },

        async salva() {
            if (!this.$refs.formMezzo.validate()) return;

            this.salvataggio = true;
            try {
                const { id, ...dati } = this.form;
                await this.$store.dispatch("mezzi/salva", { id, dati });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
